import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import RVContext, { RvContextWrapper } from "../../RVContext";
import { Route, Switch } from "react-router";
import RVProperties from "./RVProperties";
import SearchProperty from "./SearchProperty";
import Strings from "@my-dld/assets/strings";
import PageContent from "@my-dld/components/PageContent";
import Properties from "./Properties";
import RVPropertyInfo from "./RVPropertyInfo";
import RVDocuments from "./RVDocuments";
import RVReason from "./RVReason";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import RVSummary from "./RVSummary";
import RVRequests from "./Requests/RVRequests";
import RVRequestDetails from "./RVRequestDetails";

class Index extends Component <RoutedViewProps> {
	static contextType = RVContext;
	context!: React.ContextType<typeof RVContext>;

	constructor( props: RoutedViewProps ) {
		super( props );
	}

	render() {
		const pp = this.props.match.url;
		return <RvContextWrapper { ...this.context }>
			<Switch>
				<Route
					path={ pp + "/requests" } exact={ true }
					component={ RVRequests }/>
				<Route path={ pp + "/request/:reqNo" } component={ RVRequestDetails }/>
				<Route component={ RVRequest }/>
			</Switch>
		</RvContextWrapper>;
	}
}

class RVRequest extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <PageContent title={ Strings.rental_evaluation } hideQLinks={ true }>
			<PageTitle title={ Strings.rental_evaluation } paths={ [ DashboardBCItem ] }/>
			<Switch>
				<Route path={ pp + "/rvproperties" } component={ RVProperties }/>
				<Route path={ pp + "/searchProperty" } component={ SearchProperty }/>
				<Route path={ pp + "/properties" } component={ Properties }/>
				<Route path={ pp + "/rvPropertyInfo" } component={ RVPropertyInfo }/>
				<Route path={ pp + "/rvDocuments" } component={ RVDocuments }/>
				<Route path={ pp + "/rvReason" } component={ RVReason }/>
				<Route path={ pp + "/rvSummary" } component={ RVSummary }/>
				<Route path={ pp } exact={ true } component={ RVProperties }/>
			</Switch>
		</PageContent>;
	}
}

export default Index;
